import { useState, useEffect } from "react";
import { Input, DatePicker, Pagination, message, ConfigProvider, Image } from "antd";
import { PAGINATION_PAGE_OPTIONS } from "../../../constant/constants";
import ReportTable from "./ReportTable";
import { ReportService } from "../../../services/reports-services";
import dayjs from "dayjs";
import useUserStore from "../../../stores/store";
import { isDate1GreaterThanDate2 } from "../../../utils/Common";
import { useNavigate } from "react-router-dom";

export default function CouponsReportComponent({
  reportData,
  setCouponsFilter,
  handleFilterApply,
  page,
  perPage,
  setPerPage,
  total,
  handlePageChange,
  setIsFilterClear,
  handleDownload,
  loading,
}) {
  const { showNotification } = useUserStore();
  const [searchKey, setSearchKey] = useState("");
  const [fromDateTime, setFromDateTime] = useState("");
  const [toDateTime, setToDateTime] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    setCouponsFilter((prev) => ({
      ...prev,
      searchKey,
      fromDateTime,
      toDateTime,
      page,
      perPage,
    }));
  }, [searchKey, fromDateTime, toDateTime, page, perPage]);


  function onHandleSearchKey(e) {
    const val = e.target.value;
    if (ReportService.isTextValid(val)) {
      return;
    }
    setSearchKey(val);
  }

  function onHandleFromDate(date, dateString) {
    const formattedDate = date.format('YYYY-MM-DD HH:mm:ss');
    if (isDate1GreaterThanDate2(dateString, toDateTime)) {
      showNotification("From Date time cannot be greater than To Date time.");
      return;
    }

    setFromDateTime(formattedDate);
  }

  function onHandleToDate(date, dateString) {
    if (date) {
      const selectedTime = date.format("HH:mm:ss");
      const timeToSet = selectedTime === "00:00:00" ? "23:59:59" : selectedTime;
      const tempToDate = date.format(`YYYY-MM-DD ${timeToSet}`);

      if (fromDateTime != "" && !(new Date(tempToDate) >= new Date(fromDateTime))) {
        message.warning("This date must be grater than from date.");
        setToDateTime("");
        return;
      }
      setToDateTime(tempToDate);
    } else {
      setToDateTime("");
    }
  }

  function onHandleClearFilter() {
    setIsFilterClear(true);
    setSearchKey("");
    setFromDateTime("");
    setToDateTime("");

    setCouponsFilter((prev) => ({
      restaurantId: prev.restaurantId,
      page: 1,
      perPage: 10,
    }));
  }

  function onHandleView(reportId) {
    if (reportId == null) {
      showNotification("Something went wrong. Try again later.");
      return;
    };
    let url = `/reports/orders/${reportId}/details`;
    navigate(url);
  }

  return (
    <section>
      {/* revenue board */}

      {/* filters */}
      <ConfigProvider
        theme={{
          components: {
            DatePicker: {
              zIndexPopup: 1,
            },
            Select: {
              zIndexPopup: 1,
            },
          },
        }}
      >
        <div className="flex items-center gap-x-[20px] space-between w-full mt-[20px] mb-[31px]">
          <div className="flex items-center space-x-[15px] items-center w-full">
            <div className="h-[48px] w-[20%]">
              <Input
                className="h-full w-full"
                value={searchKey || ""}
                onChange={onHandleSearchKey}
                placeholder="Search key"
              />
            </div>
            <div className="h-[48px] w-[20%]">
              <DatePicker
                className={"h-full w-full"}
                showTime={{ format: "HH:mm", showSecond: false }}
                format="YYYY-MM-DD HH:mm"
                onChange={onHandleFromDate}
                placeholder="Valid From Date/time"
                needConfirm
                value={fromDateTime ? dayjs(fromDateTime) : null}
              // disabledDate={(current) => current && current > dayjs().endOf("day")}
              />
            </div>
            <div className="h-[48px] w-[20%]">
              <DatePicker
                className={"h-full w-full"}
                showTime={{ format: "HH:mm", showSecond: false }}
                format="YYYY-MM-DD HH:mm"
                onChange={onHandleToDate}
                placeholder="Valid Until Date/time"
                needConfirm
                value={toDateTime ? dayjs(toDateTime) : null}
              // disabledDate={(current) => {
              //   if (!fromDateTime) {
              //     return current && current > dayjs().endOf("day");
              //   }
              //   return (current && current < dayjs(fromDateTime).startOf("day")) || current > dayjs().endOf("day");
              // }}
              />
            </div>

          </div>
          <div className="flex items-center space-x-[20px] h-[48px] w-[300px]">
            <button
              className="w-full h-full bg-black text-[14px] font-bold leading-[16px] text-white rounded-[5px] w-[50%]"
              onClick={onHandleClearFilter}
            >
              Clear
            </button>
            <button
              className="w-full h-full bg-[#FCBD10] text-[14px] font-bold leading-[16px] text-black rounded-[5px] w-[50%]"
              onClick={handleFilterApply}
            >
              Apply
            </button>

            <div className="w-[50%]">
              <button className="h-[48px] w-[48px]" onClick={handleDownload}>
                <Image src="/images/icons/download.svg" preview={false} alt="download-report" />
              </button>
            </div>
          </div>
        </div>
      </ConfigProvider>


      {/* coupons report table */}
      <div>
        <ReportTable
          data={reportData}
          context={"coupons"}
          page={page}
          perPage={perPage}
          isLoading={loading}
          // actions={[]}
          handleView={() => {}}
        />

        <div className="mt-[20px] mb-[50px] report-pagination relative custom-pagination-options">
          <Pagination
            showSizeChanger
            onChange={handlePageChange}
            onShowSizeChange={(current, size) => {
              setPerPage(size);
            }}
            current={page}
            pageSize={perPage}
            total={total}
            pageSizeOptions={PAGINATION_PAGE_OPTIONS}
            locale={{ items_per_page: "" }}
            showSearch={false}
            showQuickJumper={false}
          />

          <div
            className="absolute h-[48px] flex items-center space-x-[40px] 
          top-0 right-[122px] text-[18px] font-medium text-[#7D7D7D] mr-3"
          >
            <div>Total: {total}</div>
            <div>Row </div>
          </div>
        </div>
      </div>
    </section>
  );
}
